import './tstrauss/style';
import FormStructure from './tstrauss/form_structure';

export default FormStructure;